<template>
  <transition name="slide-up">
    <div 
      v-if="showInstallPrompt && !isInstalled" 
      class="fixed bottom-4 left-4 right-4 md:left-1/2 md:right-auto md:transform md:-translate-x-1/2 z-50 max-w-md w-auto md:w-full"
    >
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-2xl border border-gray-200 dark:border-gray-700 p-4 flex items-center gap-3 md:gap-4">
        <div class="flex-shrink-0">
          <img 
            :src="`${publicPath}icons/web-app-manifest-192x192.png`"
            alt="App Icon" 
            class="w-10 h-10 md:w-12 md:h-12 rounded-lg"
          />
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="text-sm font-semibold text-gray-900 dark:text-white">
            Install App
          </h3>
          <p class="text-xs text-gray-600 dark:text-gray-400 mt-0.5 hidden sm:block">
            Install this app on your device for quick and easy access
          </p>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button
            @click="installPWA"
            class="px-3 py-2 md:px-4 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-md transition-colors"
          >
            Install
          </button>
          <button
            @click="dismissInstallPrompt"
            class="px-2 py-2 md:px-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-sm transition-colors"
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { usePWAInstall } from '@/composables/usePWAInstall'

const { showInstallPrompt, isInstalled, installPWA, dismissInstallPrompt } = usePWAInstall()
const publicPath = process.env.BASE_URL || '/portal/'
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease-out;
}

.slide-up-enter-from {
  transform: translate(-50%, 100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translate(-50%, 100%);
  opacity: 0;
}
</style>
